import CourseService from '@/services/API/CourseService';
import CourseEnrollmentService from '@/services/API/CourseEnrollmentService';
import CourseUnitService from '@/services/API/CourseUnitService';
import CoursesExchangeService from '@/services/API/CoursesExchangeService';
import GroupService from '@/services/API/GroupService';
import LessonService from '@/services/API/LessonService';
import TaskService from '@/services/API/TaskService';
import WebinarService from '@/services/API/WebinarService';
import SystemService from '@/services/API/SystemService';
import TagService from '@/services/API/TagService';
import ChatService from '@/services/API/ChatService';
import CategoriesService from '@/services/API/CategoriesService';
import UserService from '@/services/API/UserService';
import DirectoryService from '@/services/API/DirectoryService';
import AuthService from '@/services/API/AuthService';
import NotificationService from '@/services/API/NotificationService';
import WidgetService from '@/services/API/WidgetService';
import CertificateService from '@/services/API/CertificateService';
import TeacherService from '@/services/API/TeacherService';
import ScheduleService from '@/services/API/ScheduleService';
import ContactsService from '@/services/API/ContactsService';
import JournalAnswer from '@/services/API/JournalAnswer';
import MeetingService from '../services/API/MeetingService';
import UserDataService from '../services/API/UserDataService';
import TelegramService from '../services/API/TelegramService';
import ModuleService from '../services/API/ModuleService';
import ContractsService from '../services/API/ContractsService';
import GptPulseService from '../services/API/GptPulse';
import MentoringService from '../services/API/MentoringService';
import DiplomaService from '../services/API/DiplomaService';
import PaymentInvoceService from '../services/API/PaymentInvoce';
import ContractHeader from '../services/API/ContractHeader';
import UnitFaq from '../services/API/UnitFaq';
import Exports from '../services/API/Exports';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue) {
    const repositories = {
      courses: CourseService,
      courseUnits: CourseUnitService,
      lessons: LessonService,
      enrollments: CourseEnrollmentService,
      exchange: CoursesExchangeService,
      groups: GroupService,
      tasks: TaskService,
      webinars: WebinarService,
      system: SystemService,
      tag: TagService,
      chat: ChatService,
      categories: CategoriesService,
      users: UserService,
      dir: DirectoryService,
      auth: AuthService,
      notifications: NotificationService,
      widgets: WidgetService,
      certificates: CertificateService,
      teachers: TeacherService,
      schedule: ScheduleService,
      meeting: MeetingService,
      contacts: ContactsService,
      journal: JournalAnswer,
      userData: UserDataService,
      telegram: TelegramService,
      modules: ModuleService,
      contracts: ContractsService,
      gptPulse: GptPulseService,
      mentoring: MentoringService,
      diploma: DiplomaService,
      paymentInvoice: PaymentInvoceService,
      contractHeader: ContractHeader,
      unitFaq: UnitFaq,
      exports: Exports,
    };

    Vue.api = repositories;
    Vue.prototype.$api = repositories;
  },
};
